let conversationId = null;
let callId = null;

function isPageVisible() {
  if (typeof document === 'undefined') return false;
  return document.visibilityState === 'visible';
}

export function getNotifyFocus() {
  return {
    conversationId,
    callId,
    visible: isPageVisible()
  };
}

export function shouldSuppressOsNotification({ type, conversationId: convId, callId: incomingCallId }) {
  if (!isPageVisible()) return false;
  if (type === 'incoming-call') {
    return Boolean(callId && incomingCallId && String(callId) === String(incomingCallId));
  }
  if (type === 'new-message') {
    return Boolean(conversationId && convId && String(conversationId) === String(convId));
  }
  return false;
}

function postToSw() {
  try {
    navigator.serviceWorker?.controller?.postMessage({
      type: 'focus-state',
      conversationId,
      callId,
      visible: isPageVisible()
    });
  } catch {
    // ignore
  }
}

export function setFocusedConversation(id) {
  conversationId = id || null;
  postToSw();
}

export function setActiveCall(id) {
  callId = id || null;
  postToSw();
}

export function startFocusSync() {
  if (typeof document === 'undefined') return () => {};
  const onVis = () => postToSw();
  document.addEventListener('visibilitychange', onVis);
  window.addEventListener('focus', onVis);
  window.addEventListener('blur', onVis);
  const onMessage = (event) => {
    if (event.data?.type === 'request-focus-state') postToSw();
  };
  navigator.serviceWorker?.addEventListener?.('message', onMessage);
  postToSw();
  return () => {
    document.removeEventListener('visibilitychange', onVis);
    window.removeEventListener('focus', onVis);
    window.removeEventListener('blur', onVis);
    navigator.serviceWorker?.removeEventListener?.('message', onMessage);
  };
}

export function setPendingConversation(id) {
  try {
    if (id) sessionStorage.setItem('ashiiane-open-conversation', id);
  } catch {
    // ignore
  }
}

export function consumePendingConversation() {
  try {
    const id = sessionStorage.getItem('ashiiane-open-conversation');
    sessionStorage.removeItem('ashiiane-open-conversation');
    return id || null;
  } catch {
    return null;
  }
}

export function openFromNotification(data = {}) {
  if (data.type === 'new-message' && data.conversationId) {
    setPendingConversation(data.conversationId);
  }

  const native = typeof window !== 'undefined' && Boolean(window.Capacitor?.isNativePlatform?.());
  if (data.type === 'incoming-call' && data.callId) {
    const params = new URLSearchParams();
    if (data.callerId) params.set('peer', data.callerId);
    params.set('role', 'callee');
    params.set('type', data.callType === 'video' ? 'video' : data.callType || 'audio');
    const qs = `?${params.toString()}`;
    if (native) {
      window.location.hash = `#/call/${data.callId}${qs}`;
    } else {
      window.location.assign(`/call/${data.callId}${qs}`);
    }
    return;
  }

  if (native) {
    window.location.hash = '#/chat';
  } else if (!window.location.pathname.startsWith('/chat')) {
    window.location.assign('/chat');
  }
}
